export enum ContainerStatusEnum {
    FullInTransit = "Full in Transit",
    FullInTransitHub = "Full in Transit Hub",
    FullInHub = "Full in Hub",
    Unpack = "Unpack",
    Pack = "Pack",
    ReadyForPickup = "Ready for Pickup",
    MTInTransit = "MT in Transit",
    MTInTransitHub = "MT in transit Hub",
    MTInHub = "MT in Hub",
    Dehired = "Dehired",
    Pending = "Pending",
    Inbound = "Inbound",
    Arrived = "Arrived",
    Discharged = "Discharged",
    Available = "Available",
    GateOut = "Gate Out",
    Active = "Active",
    ShipAtWharf = "Ship At Wharf",
    WaitingRail = "Waiting Rail",
    OnRail = "On Rail",
    Inland = "Inland",
    Cleared = "Cleared",
    Wharf = "Wharf",
    OnVessel = "On Vessel",
    Departed = "Departed",
    Missed = "Missed",
    Hold = "Hold",
    Unknown = "Unknown"
}